import { getData, selectAll, select, getHeight, getTopOffset, on, getAttribute } from 'helpers/dom'
import throttle from 'lodash.throttle'
import { useEffect, useRef, useState } from 'preact/hooks'
import { formatMoney } from 'libs/shopify'
import ProductATC from 'snippets/product-atc/product-atc'

const selectors = {
  ANCHOR_CLASS: '.js-anchor-section',
  ANCHOR_ID_ATTR: 'anchor-id',
  ANCHOR_ITEM_SELECTOR: '.js-anchor-section-item',
  PRODUCT_FORM_CLASS: '.js-product-form',
  STICKY_ATC_CLASS: 'sticky-atc'
}

function AnchorSection() {
  const productFormEl = select(selectors.PRODUCT_FORM_CLASS)
  const formInvisibleBeforeScroll = window.innerHeight < (getTopOffset(productFormEl) || 0)
  const [itemsData, setItemsData] = useState([])
  const [currentIndex, setCurrentIndex] = useState('')
  const [isShownOnTarget, setIsShownOnTarget] = useState(formInvisibleBeforeScroll)
  const [currentVariant, setCurrentVariant] = useState(window.productState.initProduct.initVariant)

  useEffect(() => {
    setItemsData(
      selectAll(selectors.ANCHOR_ITEM_SELECTOR).map((item, index) => ({
        index,
        id: getAttribute('id', item),
        title: getData('title', item),
        active: false
      }))
    )
  }, [])

  useEffect(() => {
    if (itemsData.length) {
      handleScroll()
    }
  }, [itemsData])

  const handleScroll = () => {
    on(
      'scroll',
      throttle(() => {
        const topScroll = Math.floor(window.scrollY + getStickyHeight())
        for (let i = 0; i < itemsData.length; i++) {
          const item = itemsData[i]
          const itemEl = select(`#${item.id}`)
          if (itemEl) {
            const topOffset = Math.floor(getTopOffset(itemEl))
            if (topScroll >= topOffset) {
              setCurrentIndex(item.id)
            }
          }
        }

        checkScrollShowTarget()
      }, 100),
      window
    )
  }

  const checkScrollShowTarget = () => {
    const formInvisibleBeforeScroll = window.innerHeight < getTopOffset(productFormEl)
    const formInvisibleAfterScroll = window.pageYOffset > getTopOffset(productFormEl) + getHeight(productFormEl) - getStickyHeight() - 56
    const formVisible = getTopOffset(productFormEl) < window.innerHeight + window.scrollY

    const productBundlesEl = select('.product-bundles')
    let productBundlesVisible = false
    if (productBundlesEl) {
      const bundlesTop = getTopOffset(productBundlesEl)
      const bundlesBottom = bundlesTop + getHeight(productBundlesEl)
      const viewportTop = window.scrollY
      const viewportBottom = window.scrollY + window.innerHeight
      productBundlesVisible = bundlesTop < viewportBottom && bundlesBottom > viewportTop
    }
    if (productBundlesVisible) {
      setIsShownOnTarget(false)
      document.body.classList.remove(selectors.STICKY_ATC_CLASS)
      return
    }

    if (formInvisibleAfterScroll || (!formInvisibleAfterScroll && !formVisible && formInvisibleBeforeScroll)) {
      setIsShownOnTarget(true)
      document.body.classList.add(selectors.STICKY_ATC_CLASS)
    } else {
      setIsShownOnTarget(false)
      document.body.classList.remove(selectors.STICKY_ATC_CLASS)
    }
  }

  const handleScrollToForm = () => {
    const offset = getTopOffset(productFormEl) - getStickyHeight()
    window.scrollTo({ top: offset, behavior: 'smooth' })
  }

  const getStickyHeight = () => {
    let stickyHeight = 0
    const anchorSectionEl = select(selectors.ANCHOR_CLASS)
    const headerStickyHeight = window.innerWidth < 768 ? 56 : 75
    stickyHeight += headerStickyHeight + getHeight(anchorSectionEl)

    return stickyHeight
  }
  return (
    <>
      <div
        className={`js-anchor-section fixed bottom-0 left-0 right-0 z-20 hidden translate-y-full gap-6 border-t border-default bg-white opacity-0 transition-all duration-300 ease-in-out md:block  ${
          isShownOnTarget && '!translate-y-0 border-b border-default !opacity-100'
        }`}
      >
        <div className="container hidden items-center justify-between overflow-auto py-4 md:flex">
          <div className="hidden items-center gap-3 lg:flex font-heading">
            <span className="text-xl text-grey-1000">{window.productState.initProduct.title}</span>
            <span className="text-xl text-grey-300">-</span>
            <span className="text-xl text-grey-1000">{formatMoney(currentVariant.price)}</span>
          </div>

          <div className="flex w-full items-center gap-4 lg:w-fit">
            <ProductATC
              currentVariant={currentVariant}
              buttonText="Add to cart"
              buttonClass="relative button-primary ml-auto"
              buttonWrapperClass="mt-0 flex-1 [&>div]:flex-row [&>div>button]:m-0 [&>div>button]:whitespace-nowrap [&>.animate-pulse>div]:m-0"
              initProduct={window.productState.initProduct}
              isAnchorSection={true}
            />
          </div>
        </div>
      </div>
      <div
        className={`fixed bottom-0 left-0 right-0 z-20 flex translate-y-full items-center justify-center gap-4 rounded-none border-t border-default bg-white p-4 opacity-0 transition-all duration-300 ease-in-out md:hidden  ${
          isShownOnTarget && '!translate-y-0 border-b border-default !opacity-100'
        }`}
      >
        <ProductATC
          currentVariant={currentVariant}
          buttonText="Add to cart"
          buttonClass="relative w-full button-primary"
          buttonWrapperClass="mt-0 w-full [&>div>button]:m-0 [&>.animate-pulse>div]:m-0"
          initProduct={window.productState.initProduct}
          isAnchorSection={true}
          showQty={true}
        />
      </div>
    </>
  )
}

export default AnchorSection
